import React from 'react';
import type { PreloadedQuery } from 'react-relay';
import { graphql, usePreloadedQuery } from 'react-relay';
import type { multiHcDropdownContentComponentQuery } from './__generated__/multiHcDropdownContentComponentQuery.graphql';
import { MultiHcDropdownContent } from './multi-hc-dropdown-paginated';

export interface ComponentProps {
    toggleSeparatorVisibility: (isVisible: boolean) => void;
    renderQueryError: () => JSX.Element;
    onHelpCenterClick?: () => void;
    queryRef: PreloadedQuery<multiHcDropdownContentComponentQuery>;
}

export const MultiHcDropdownContentComponent: React.FC<ComponentProps> = (props) => {
    const data = usePreloadedQuery(
        graphql`
            query multiHcDropdownContentComponentQuery(
                $cloudId: ID!
                $workspaceAri: ID!
                $SORT_ORDER: HelpCenterSortOrder!
                $NUMBER_OF_HELP_CENTERS_PER_FETCH: Int!
            ) {
                ...multiHcDropdownPaginatedFragment
                    @arguments(
                        cloudId: $cloudId
                        workspaceAri: $workspaceAri
                        SORT_ORDER: $SORT_ORDER
                        NUMBER_OF_HELP_CENTERS_PER_FETCH: $NUMBER_OF_HELP_CENTERS_PER_FETCH
                    )
            }
        `,
        props.queryRef
    );
    return <MultiHcDropdownContent {...props} helpCentersKey={data} />;
};
